export const SET_JOBS_HOME_PAGE = 'SET_JOBS_HOME_PAGE';
export const SET_JOBS = 'SET_JOBS';
export const SET_JOB_DESCRIPTION_PAGE = 'SET_JOB_DESCRIPTION_PAGE';
export const SET_JOB_DESCRIPTION_CALL_TO_ACTION = 'SET_JOB_DESCRIPTION_CALL_TO_ACTION';



// WEBPACK FOOTER //
// ./app/actions/company.js